import { getDigitalOrderCsv } from '@/concepts/Orders/repository/getDigitalOrderCsv'
import { parametrizeString } from './parametrizeString'

const handleCsvDownload = async (productId: string, productName: string) => {
  const csv = await getDigitalOrderCsv(productId)

  const url = window.URL.createObjectURL(new Blob([String(csv)]))
  const link = document.createElement('a')
  const fileName = `product-${parametrizeString(productName)}.csv`
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export { handleCsvDownload }
